var _ellipse, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard2Acorn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 129,
    viewBox: "0 0 120 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.5126,
    cy: 38.2671,
    rx: 17.7485,
    ry: 22.0425,
    transform: "rotate(16.2249 66.5126 38.2671)",
    fill: "#C1CD9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.1207 53.9868C57.6099 71.6383 46.56 83.8187 39.4401 81.1925C32.3202 78.5663 24.9592 65.9165 31.4699 48.2651C37.9807 30.6136 58.1463 14.0837 63.0178 17.2709C67.4798 23.1087 67.2469 35.5352 64.1207 53.9868Z",
    fill: "#C1CD9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7317 66.9392C89.5276 87.4037 68.8301 100.37 59.6931 97.2841C50.556 94.1983 36.8597 83.7641 50.999 56.2346C58.9868 40.6822 76.1777 23.5021 84.9796 24.2872C94.1525 29.5832 97.8104 54.8332 94.7317 66.9392Z",
    fill: "#C1CD9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9331 92.3892C56.1519 87.1958 65.7097 77.7243 77.2958 75.3832C90.0189 72.8123 96.7893 75.399 98.2767 76.2578C95.7855 82.8629 86.6502 97.3115 75.3042 100.016C63.9583 102.721 56.4617 102.69 54.1316 102.337C52.7318 105.715 49.1996 112.711 46.2696 113.664C43.3395 114.617 42.6581 114.003 42.6837 113.577C41.9621 113.491 40.5782 112.758 40.8155 110.515C41.0527 108.272 44.922 102.639 46.827 100.103C41.4173 97.6403 29.8161 91.2069 26.69 85.1709C22.7823 77.626 17.635 69.3654 21.6735 55.5C26.8516 56.8369 33.7043 58.4794 41.5066 66.9507C49.3089 75.4219 52.3752 87.4394 52.9331 92.3892Z",
    fill: "#C1CD9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2Acorn);
export default __webpack_public_path__ + "static/media/card-2-acorn.1fee0bab10ec634e84c9c47713660d76.svg";
export { ForwardRef as ReactComponent };